import React from "react";
import { Box, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import PlaceIcon from "@mui/icons-material/Place";
import { StoreThemeTokens } from "./themes/storeThemes";

interface AnnouncementBarProps {
  announcementData?: {
    show_announcement?: boolean;
    top_tagline?: string;
    announcement_text?: string;
    location_badge?: string;
  };
  themeTokens: StoreThemeTokens;
}

const AnnouncementBar: React.FC<AnnouncementBarProps> = ({
  announcementData,
  themeTokens,
}) => {
  const show =
    announcementData?.show_announcement !== undefined
      ? Boolean(announcementData.show_announcement)
      : true;

  if (!show) return null;

  const tagline =
    announcementData?.top_tagline;
  const text =
    announcementData?.announcement_text;
  const location = announcementData?.location_badge;

  return (
    <Box
      component="aside"
      sx={{
        bgcolor: themeTokens.bgFooter,
        color: themeTokens.bgFooterText,
        py: 1,
        px: { xs: 2, sm: 3, md: 4 },
        fontSize: "0.75rem",
        fontWeight: 500,
        letterSpacing: "0.04em",
        borderBottom: `1px solid rgba(255,255,255,0.08)`,
        position: "relative",
        zIndex: 51,
      }}
    >
      <Box
        sx={{
          maxWidth: 1280,
          mx: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        {/* Left: Star / Brand Tagline */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            gap: 1,
            color: themeTokens.accent,
            fontSize: "0.75rem",
          }}
        >
          <StarIcon sx={{ fontSize: 14 }} />
          <Typography
            variant="caption"
            sx={{
              color: "rgba(255,255,255,0.8)",
              fontSize: "0.75rem",
              fontWeight: 400,
            }}
          >
            {tagline}
          </Typography>
        </Box>

        {/* Center: Highlights */}
        <Box
          sx={{
            mx: { xs: "auto", md: 0 },
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            textAlign: "center",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              fontSize: { xs: "0.7rem", sm: "0.75rem" },
              fontWeight: 500,
              color: "#FFFFFF",
              letterSpacing: "0.03em",
            }}
          >
            {text}
          </Typography>
        </Box>

        {/* Right: Location */}
        {location && (
          <Box
            sx={{
              display: { xs: "none", lg: "flex" },
              alignItems: "center",
              gap: 0.5,
              color: "rgba(255,255,255,0.8)",
            }}
          >
            <Typography variant="caption" sx={{ fontSize: "0.75rem" }}>
              {location}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AnnouncementBar;
